const rootActionPath = 'core/BonusOffersFlexPage';

export const BONUS_OFFERS_FLEX_PAGE_VIEW = `${rootActionPath}/VIEW`;
export const BONUS_OFFERS_FLEX_PAGE_SECTION_VIEW = `${rootActionPath}/SECTION/VIEW`;
